import { render, staticRenderFns } from "./AttachDocument.vue?vue&type=template&id=fc391838&"
import script from "./AttachDocument.vue?vue&type=script&lang=js&"
export * from "./AttachDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports